import { useCallback, useState } from 'react';

import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import * as Yup from 'yup';

import Input from '@/components/form/Input';
import { updateUser } from '@/store/profile/thunks';
import { showError, showSuccess } from '@/utils';

import SectionForm from '../SectionForm';

function Password({ title, description }) {
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const [loading, setLoading] = useState(false);

	const validationSchema = Yup.object({
		password: Yup.string().min(3).max(50).required()
	});

	const methods = useForm({
		resolver: yupResolver(validationSchema),
		mode: 'onChange',
		defaultValues: {
			password: ''
		}
	});

	const onSubmit = useCallback(async function (values) {
		setLoading(true);
		dispatch(
			updateUser({
				password: values.password
			})
		)
			.unwrap()
			.then(() => {
				setLoading(false);
				showSuccess(t('account.toast'));
			})
			.catch(error => {
				showError(error);
				setLoading(false);
			})
			.finally(() => {
				methods.reset({ password: '' });
			});
	}, []);

	return (
		<SectionForm
			title={title}
			description={description}
			methods={methods}
			onSubmit={onSubmit}
			loading={loading}
		>
			<div className="m-0 flex w-full flex-col items-center">
				<div className="flex w-full flex-col gap-x-5 gap-y-4 lg:gap-y-6">
					<Input
						type="password"
						label={t('common.password')}
						autoComplete="new-password"
						name="password"
						placeholder="********"
						size="lg"
					/>
				</div>
			</div>
		</SectionForm>
	);
}

export default Password;
